// this is a copy of @tm.is/numberformat until toyota web will be added to turborepo

const zeroFormat = '0'
const delimiters = {
  decimal: ',',
  thousands: '.',
}

type Round = (value: number) => number

/**
 * Implementation of toFixed() that treats floats more like decimals
 *
 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
 * problems for accounting- and finance-related software.
 */
function toFixed(value: number, precision: number, roundingFunction?: Round, optionals?: number) {
  const power = Math.pow(10, precision)
  let optionalsRegExp
  let output

  roundingFunction = roundingFunction !== undefined ? roundingFunction : Math.round
  // Multiply up by precision, round accurately, then divide and use native toFixed():
  output = (roundingFunction(value * power) / power).toFixed(precision)

  if (optionals) {
    optionalsRegExp = new RegExp('0{1,' + optionals + '}$')
    output = output.replace(optionalsRegExp, '')
  }

  return output
}

function formatNumber(value: number, format: string, roundingFunction?: Round) {
  let optDec = false
  let neg = false
  let d = ''
  let precision
  let thousands
  let w

  // check if number is zero and a custom zero format has been set
  if (value === 0 && zeroFormat !== null) {
    return zeroFormat
  } else {
    if (format.indexOf('[.]') > -1) {
      optDec = true
      format = format.replace('[.]', '.')
    }

    w = value.toString().split('.')[0]
    precision = format.split('.')[1]
    thousands = format.indexOf(',')

    if (precision) {
      if (precision.indexOf('[') > -1) {
        precision = precision.replace(']', '')
        precision = precision.split('[')
        d = toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length)
      } else {
        d = toFixed(value, precision.length, roundingFunction)
      }
      const dSplited = d.split('.')
      w = dSplited[0]

      if (dSplited[1] && dSplited[1].length) {
        d = delimiters.decimal + dSplited[1]
      } else {
        d = ''
      }

      if (optDec && Number(d.slice(1)) === 0) {
        d = ''
      }
    } else {
      w = toFixed(value, 0, roundingFunction)
    }

    // format number
    if (w.indexOf('-') > -1) {
      w = w.slice(1)
      neg = true
    }

    if (thousands > -1) {
      w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + delimiters.thousands)
    }

    if (format.indexOf('.') === 0) {
      w = ''
    }

    return (neg ? '-' : '') + w + d
  }
}

export type ParseFormatedNumber = (value?: string | null | undefined) => number

export const parseFormatedNumber: ParseFormatedNumber = (value) => {
  if (!value) {
    return 0
  } else {
    const neg = value.trim().indexOf('-') === 0
    value = value.replace(/\./g, '').replace(delimiters.decimal, '.')

    return (neg ? -1 : 1) * Number(value.replace(/[^0-9\.]+/g, ''))
  }
}

export type FormatNumber = (value?: number | string | null | undefined) => string

export const makeFormatNumber =
  (pattern: string = '0,0'): FormatNumber =>
  (value) => {
    if (value === undefined || value === null || value === '' || isNaN(value as number)) {
      return ''
    }
    return formatNumber(typeof value === 'string' ? Number(value) : value, pattern)
  }
